export const servicesData = [
  {
    id: 1,
    icon: 'ri-computer-line',
    title: '2. El Bilgisayar Alım',
    description: 'Kullanılmış bilgisayarınızı en uygun fiyata değerlendiriyoruz',
    slug: 'ikinci-el-bilgisayar-alim',
  },
  {
    id: 2,
    icon: 'ri-tools-line',
    title: 'Bilgisayar Tamiri',
    description: 'Profesyonel ekibimizle hızlı ve garantili tamir hizmeti',
    slug: 'bilgisayar-tamiri',
  },
  {
    id: 3,
    icon: 'ri-macbook-line',
    title: 'Laptop Servisi',
    description: 'Tüm marka laptop tamiri ve bakım hizmetleri',
    slug: 'laptop-servisi',
  },
  {
    id: 4,
    icon: 'ri-building-line',
    title: 'Kurumsal Destek',
    description: 'Şirketler için özel teknik destek ve bakım paketleri',
    slug: 'kurumsal-destek',
  },
];